export default __webpack_public_path__ + "static/media/church-icons.d5651693.svg";